#import "../fragments/zoom-meeting-timeline-fragment.graphql"
#import "../fragments/entity-summary.graphql"

query GetActivity($activityId: ID!) {
    activity(id: $activityId) {
        id
        name
        logNote {
            id
            bodyHtml
        }
        externalMeeting {
            ...ZoomMeetingTimelineFragment
        }
        summary {
            ...EntitySummary
        }
        transcription
        participants {
            id
            name
            htmlUrl
        }
        activityType {
            id
            name
        }
        startTime
        endTime
        shouldSummarize
        externalMeetingServiceType
    }
}
